export const jobGrade = [
  { id: 1, jobGrade: "G1-Default" },
  { id: 2, jobGrade: "G2-Executive" },
  { id: 3, jobGrade: "G3-Senior Executive" },
  { id: 4, jobGrade: "G4-Assistant Manager" },
  { id: 5, jobGrade: "G5-Manager" },
  { id: 6, jobGrade: "G6-Senior Manager" },
  { id: 7, jobGrade: "G7-Engineer" },
  { id: 8, jobGrade: "G8-Senior Engineer" }
]


